import React, { ReactNode, Suspense } from 'react';
import './EditorLayout.scss';
import { InternalApiScenarioLanguage } from '../../api-internal';
import { SalvDropdown, SalvFieldHeader, Size } from '@salvapp/ui-components';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';

const Editor = React.lazy(() => import('../../common/editor/Editor'));

export interface EditorLayoutProps {
  disabled: boolean;
  parameters?: ReactNode;
  footer?: ReactNode;
  editorType: InternalApiScenarioLanguage;
  editorValue: string;
  editorOnChange: (newValue: string) => void;
  syntaxHighlight?: boolean;
  showLanguageDropdown?: boolean;
}

export const editorLanguageOptions: DropdownOption[] = Object.keys(InternalApiScenarioLanguage).map((key) => {
  return { key: key, label: key, value: key };
});

const EditorLayout = ({
  disabled,
  parameters,
  footer,
  editorType,
  editorValue,
  editorOnChange,
  syntaxHighlight = false,
  showLanguageDropdown = false,
}: EditorLayoutProps) => {
  return (
    <div className='salv-editor-layout d-flex'>
      <div className='menu-column'>{parameters}</div>
      <div className='d-flex editor-container'>
        <Suspense fallback={<>Loading...</>}>
          {showLanguageDropdown && (
            <div className='language-dropdown-container'>
              <SalvFieldHeader label='Rule' size={Size.MEDIUM} />
              <SalvFieldHeader label='Language' size={Size.SMALL} />
              <SalvDropdown
                ariaLabel='Language selector'
                options={editorLanguageOptions}
                value={editorLanguageOptions.find((option) => option.value === editorType)}
                disabled={true}
              />
            </div>
          )}
          <Editor
            disabled={disabled}
            value={editorValue}
            onChange={editorOnChange}
            type={editorType}
            className='editor'
            syntaxHighlight={syntaxHighlight}
          />
        </Suspense>
        {footer}
      </div>
    </div>
  );
};

export default EditorLayout;
